import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import './progress.scss';

const propTypes = {
  children: PropTypes.node,
  /** Add custom class */
  className: PropTypes.string,
  /** Maximum value of progress */
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Current value of progress */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const Progress = (props) => {
  const {
    children,
    className,
    value = 0,
    max = 100,
    ...rest
  } = props;

  const percent = (value / max) * 100;

  const progressClasses = clsx(className, 'ap-progress');
  const barStyle = {
    width: `${percent}%`,
  };

  return (
    <div
      {...rest}
      className={progressClasses}
    >
      <div
        className="ap-progress__bar"
        style={barStyle}
      >
        {children}
      </div>
    </div>
  );
};

Progress.propTypes = propTypes;

export default Progress;
